export default __webpack_public_path__ + "static/media/EFA_ΦΑ.41c0bbb1.png";